import styles from 'styles/components/common/overlays/Modal.module.scss';

type TProps = {
  children: React.ReactNode;
  style?: React.CSSProperties;
};

const ModalWrapper = ({ children, style }: TProps) => {
  return (
    <div className={styles.modal_wrapper} style={style}>
      {children}
    </div>
  );
};

export default ModalWrapper;
